import ListingCard from "../cards/ListingCard";

const AccommodationsList = ({ listingResults }) => {
  const Listing = () =>
    listingResults?.hits.map((listing) => (
      <ListingCard
        key={listing.id}
        id={listing.id}
        className="h-full"
        data={listing}
      />
    ));

  return (
    <div className="grid grid-cols-1 gap-6 md:gap-8">
      <Listing />
    </div>
  );
};

export default AccommodationsList;
